import {
  RGB_CHANNEL_MAX,
  RGB_CHANNEL_MIN,
} from '../../ColorPickerPopoverPreview.constants'

export function parseRgbChannel(value) {
  const parsedChannel = parseInt(String(value).trim(), 10)

  if (
    !Number.isFinite(parsedChannel) ||
    parsedChannel < RGB_CHANNEL_MIN ||
    parsedChannel > RGB_CHANNEL_MAX
  ) {
    return null
  }

  return parsedChannel
}
